// Display-name helpers for inventory products.
//
// SKUs seeded from the printed Excel templates use a "{category} · {variant} · {size}"
// naming convention (e.g. "5寸 · 阿华田", "胚 · 原味 · 6\""). When the UI
// already shows 品类 as its own column, the prefix is redundant noise.
//
// `displayName(p)` strips the leading "{category} · " from the name when
// present. Legacy SKUs where the name doesn't start with the category
// (e.g. "草莓蛋糕" with category="蛋糕") are left untouched.
//
// Use this in tables/lists where the category is visible alongside.
// Keep the FULL `.name` in standalone contexts (confirm dialogs, toasts,
// Excel export, audit logs) so there's no ambiguity about which SKU.

export interface ProductLike {
  name: string;
  category?: string | null;
}

export function displayName(p: ProductLike | null | undefined): string {
  if (!p) return '';
  if (!p.category) return p.name;
  const prefix = `${p.category} · `;
  if (p.name.startsWith(prefix)) {
    return p.name.slice(prefix.length);
  }
  return p.name;
}
